import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import PropTypes from 'prop-types';
import StudentLockForm from '../../StudentService/StudentOverview/StudentLockForm';


export default class PollListTable extends React.Component {
    rowRedirect;
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        localStorage.removeItem('pollType')
    }

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.showResults === true) {
            return <Redirect push to={{ pathname: this.props.rowRedirect }} />;
        }
        let { polls, firstButtonText, firstButtonLink, firstAltButtonText, firstAltButtonLink } = this.props;
        return (

            <Fragment>

                {this.state.loading ? <Loader active inline="centered" /> :
                    polls.length ? <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={6}>Naziv anketnog upitnika</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Tip</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum objave</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum isteka</Table.HeaderCell>
                                {this.props.active ? <Table.HeaderCell colSpan={2} >Datum objave rezultata</Table.HeaderCell>
                                    : <Table.HeaderCell colSpan={3} ></Table.HeaderCell>}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {polls.map((el, index) =>
                                (<Table.Row
                                    key={index}
                                    onClick={(e) => {
                                        let poll = {
                                            pollId: el.id,
                                            pollName: el.name,
                                            pollType: el.questionnaireType.id,
                                            pollTypeKey: el.questionnaireType._key,
                                            pollStatus: el.questionnaireStatus.id,
                                            showAddQuestion: false
                                        };
                                        localStorage.setItem('poll', JSON.stringify(poll));
                                        this.setState({ showResults: true });
                                    }}
                                >
                                    <Table.Cell verticalAlign="middle">
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={6}>
                                        {el.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={3}>
                                        {el.questionnaireType.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {moment(el.activationDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {moment(el.endDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    {this.props.active ?
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {moment(el.statisticsActivationDate).format('D. M. YYYY.')}
                                        </Table.Cell>
                                        : <Table.Cell verticalAlign="middle" textAlign="center" colSpan={3}>
                                        {/* link */}
                                        <Link to={{
                                            // pathname: '',
                                            pathname: el.questionnaireType._key === 'academic staff evaluation'? firstButtonLink:firstAltButtonLink,
                                        }}
                                        >
                                            <Button
                                                onClick={() => {
                                                    let poll = {
                                                        pollId: el.id,
                                                        pollName: el.name,
                                                        pollType: el.questionnaireType.id,
                                                        pollTypeKey: el.questionnaireType._key,
                                                        pollStatus: el.questionnaireStatus.id,
                                                        showAddQuestion: false
                                                    };
                                                    localStorage.setItem('poll', JSON.stringify(poll));
                                                }}

                                                basic="true"
                                                color="blue"
                                                size="small"
                                            > {el.questionnaireType._key === 'academic staff evaluation'? firstButtonText: firstAltButtonText}
                                            </Button>

                                        </Link>
                                    </Table.Cell>}
                                </Table.Row>))}
                        </Table.Body>
                    </Table> :  <div>{this.props.active ? 'Trenutno nema aktivnih anketnih upitnika na vašoj organizacionoj jedinici.' : 'Trenutno nema arhiviranih anketnih upitnika na vašoj organizacionoj jedinici.'}</div>
                }
            </Fragment>
        );
    }
}
// PollListTable.propTypes = {
//     // eslint-disable-next-line react/require-default-props
//     polls: PropTypes.array(),
//     rowRedirect: PropTypes.number,
// };




// WEBPACK FOOTER //
// ./src/views/Poll/Util/PollListTable.js